import logo from './zebras.jpg';
import './App.css';
import Dictionary from "./Dictionary";



export default function App() {
  return (
    
    <div className="App">
      <div className='container'>
        <header className="App-header">
          <img src={logo} className='App-logo img-fluid' 
          alt='logo' />

        </header>
        <main>
          <Dictionary defaultKeyword="sunset"/>
        </main>
        <footer className='App-footer'>Coded by Johannah Makgato</footer>
      </div>
       
    </div>
  );
}


